module.exports = __webpack_public_path__ + "img/cert-27701.fd737c21.svg";